export const HOME_PAGE_PATH = '/'
